(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.error', {
            parent: 'public',
            url: '/error',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.error': {
                    templateUrl: 'app/public/error/error.html',
                    controller: 'PublicErrorController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.error': {}
                //'footer@app': {
                //    templateUrl: 'app/layouts/footer/footer.html'
                //}

            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
